// extracted by mini-css-extract-plugin
export default {"container":"Words_container__N+LHW","title":"Words_title__n1+py","subtitle":"Words_subtitle__JRVuo"};